export enum Platform {
  WebApp = 'webapp',
  IOS = 'ios',
  Android = 'android',
}
